/**
 * Convert meters per second to miles per hour
 * @param metersPerSecond Speed in meters per second
 * @returns Speed in miles per hour
 */
export function metersPerSecondToMph(metersPerSecond: number): number {
    // 1 m/s = 2.23694 mph
    return metersPerSecond * 2.23694
}

/**
 * Format speed in mph with 1 decimal place
 * @param metersPerSecond Speed in meters per second
 * @returns Formatted speed string (e.g., "45.3 mph")
 */
export function formatSpeedMph(metersPerSecond: number): string {
    const mph = metersPerSecondToMph(metersPerSecond)
    return `${mph.toFixed(1)} mph`
}
